import { useQuery } from "react-query";
import {ActivityApi, Configuration, PetApi } from '@myfamilysrl/memopet_typescript_axios_sdk'

const getPetInfo = async (accessToken, code) => {
    let data = null;
    const memopetConfig = new Configuration({
        basePath: process.env.REACT_APP_MEMOPET_API,
        // basePath: 'http://10.12.34.42:5273', //piru
        accessToken: accessToken,
    });

    const memopetApi = new PetApi(memopetConfig)

    await memopetApi.apiPetBySerialCodeSerialCodeGet(
        code,
        navigator.language.substring(0,2)
    )
    .then((res) => {
        data = res;
        console.warn("data : ", data);
    })
    .catch((err) => console.error("error on get pet by serial code", err));

    return data
};

const startActivity = async (petId) => {
    console.warn('start activity', petId)
    let data = null;
    // const memopetConfig = new Configuration({
    //     basePath: 'https://api-staging.memopet.com',
    //     accessToken: accessToken,
    // });

    // const memopetApi = new ActivityApi(memopetConfig)

    // await memopetApi.apiActivityStartPost({
    //     petId: petId
    // })
    // .then((res) => {
    //     data = res;
    // })
    // .catch((err) => console.warn(err));

    return data
};
  
export function useGetPetInfo(accessToken, code){
    return useQuery(["useGetPetInfo", accessToken, code], () => getPetInfo(accessToken, code));
}

export function useStartActivity(petId){
    return useQuery(
    ["useStartActivity"], 
    (petId) => startActivity(petId),
    {
        enabled: false,
    });
}